import { configureStore } from '@reduxjs/toolkit';
import pubLoginReducer from './slices/pubLoginSlice';
import { dropdownReducer } from "./slices/dropdownSlice";
import adLoginReducer from './slices/adLoginSlice';

const store = configureStore({
  reducer: {
    pubLogin: pubLoginReducer,
    dropdown:dropdownReducer,
    adLogin:adLoginReducer
  }
 
});

export default store;
